import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { trackEventFunction } from 'core-lib/utils/eventTracking';
import { getPlatform } from 'core-lib/utils/helpers';

const DynamicNotFound = dynamic(() => import('src/components/Custom404'), {
  ssr: false,
});

function trackErrorEvent() {
  const obj = {
    category: '404 Page',
    platform: getPlatform(),
    label: window?.location?.href,
  };
  trackEventFunction('page_not_found', obj);
}

function NotFound(props) {
  useEffect(() => {
    trackErrorEvent();
  }, []);
  //@ts-ignore
  return <DynamicNotFound {...props} />;
}

export default NotFound;
